import { AttributeExtendedClient } from '@frontend/attribute/api';
import { attributeRequest } from '@frontend/attribute/events';
import { Attribute, AttributeExtended } from '@frontend/attribute/types';
import { EntityType } from '@frontend/common';
import { CommonMessage, getCorrectTranslation, useLocale } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { ATTRIBUTE_LINKED_LABEL, AttributeDetailsCard, AttributeGeneralSection, AttributeLinkedSection } from './attribute-detail-sections';

const AttributeTitle = ({ attribute }: { attribute: Attribute | AttributeExtended }) => {
    const { locale } = useLocale();
    return <>{locale ? getCorrectTranslation(locale, attribute, 'name') : attribute.name}</>;
};

export const attributeReactiveDetail: ReactiveDetailRegistryEntry<Attribute, AttributeExtended> = {
    entityType: EntityType.ATTRIBUTE,
    resolveFunction: attributeRequest,
    fetchExtended: ({ object }) => AttributeExtendedClient.fetchExtendedAttribute(object.account_id, object.id),
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: ({ extended, object }) => <AttributeTitle attribute={extended ?? object} />,
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) =>
                view.extended ? (
                    <>
                        <AttributeDetailsCard attribute={view.extended} />
                        <AttributeGeneralSection attribute={view.extended} />
                    </>
                ) : null
        },
        {
            id: 'linked',
            label: ATTRIBUTE_LINKED_LABEL,
            render: (view) => (view.extended ? <AttributeLinkedSection attribute={view.extended} /> : null)
        }
    ]
};
